var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlucoseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon",
    fill: "#fff",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.999683,3.9999845 L17.2885882,11.4703126 C17.7793288,12.3103141 18.02516,13.2728611 17.9979649,14.2473372 C17.9660069,15.1854061 17.7043503,16.100856 17.2363491,16.9121964 C16.1510042,18.8168403 14.1445605,19.9999845 11.9998367,19.9999845 C9.85926127,19.9999845 7.85496857,18.8193191 6.76916277,16.9190131 C6.29839597,16.1045742 6.03489566,15.1854061 6.00216935,14.2434641 C5.97405243,13.2632557 6.21972998,12.2948216 6.71139243,11.448778 L6.71139243,11.448778 L11.999683,3.9999845 Z M15.3361999,13.0984076 C14.8840657,13.0984076 14.5175241,13.4765701 14.5175241,13.9430191 C14.5158451,15.4055099 13.3666757,16.5910718 11.9486122,16.592671 C11.4970271,16.5926707 11.1304855,16.9708332 11.1304855,17.4372822 C11.1304855,17.9037313 11.4970271,18.2818938 11.9491614,18.2818938 C14.2710052,18.279361 16.1522454,16.3385332 16.1548755,13.9436064 C16.1548755,13.4765701 15.7883342,13.0984076 15.3361999,13.0984076 Z",
    id: "Combined-Shape",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlucoseWhite);
export default __webpack_public_path__ + "static/media/icon-glucose-white.5876ec71d68edcc517c49de3db31e942.svg";
export { ForwardRef as ReactComponent };